export default __webpack_public_path__ + "static/media/379.81ae7dda.jpg";